import {
  MenuIcon,
  EmojiPeopleIcon,
  AppsIcon,
  DnsIcon,
  ApiIcon,
} from '@assets/icons';
import { useAppDispatch, useAppSelector } from '@hooks';
import {
  AppBar,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import { toggleMenu } from '@redux/actions';
import { Routes } from '@utils/constants';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Drawer } from './Menu.styled';

import './Menu.scss';

const MenuItem: IMenuItem[] = [
  {
    route: Routes.DEVELOPER_LIST,
    text: 'menu.developer_list',
    icon: EmojiPeopleIcon,
  },
  {
    route: Routes.APPLICATION_LIST,
    text: 'menu.application_id_list',
    icon: AppsIcon,
  },
  {
    route: Routes.SSID_LIST,
    text: 'menu.ssid_list',
    icon: DnsIcon,
  },
  {
    route: Routes.API_LIST,
    text: 'menu.api_list',
    icon: ApiIcon,
    file: true,
  },
];

const Menu: FC = () => {
  const dispath = useAppDispatch();
  const navigate = useNavigate();

  const { t } = useTranslation();
  const { openMenu } = useAppSelector((state) => state.app);

  const handleClick = (item: IMenuItem) => () => {
    if (location.pathname !== item.route) {
      navigate(item.route);
    }
  };

  return (
    <Drawer variant="permanent" open={openMenu} className="Menu">
      <AppBar position="static" className="Menu__header">
        {openMenu ? (
          <Typography variant="h4">Nabla Admin Console</Typography>
        ) : (
          <IconButton
            aria-label="menu-open"
            color="secondary"
            onClick={() => dispath(toggleMenu())}
          >
            <MenuIcon />
          </IconButton>
        )}
      </AppBar>
      <Divider />
      <List className="Menu__list" disablePadding>
        {MenuItem.map((item) => (
          <ListItem key={item.route} disablePadding className="MenuItem">
            <ListItemButton
              className="MenuItem__content"
              sx={{ justifyContent: openMenu ? 'initial' : 'center' }}
              selected={location.pathname.includes(item.route)}
              onClick={handleClick(item)}
            >
              <ListItemIcon
                className="MenuItem__content__icon"
                sx={{ mr: openMenu ? 3 : 'auto' }}
              >
                {item.file ? <img src={item.icon} alt="" /> : <item.icon />}
              </ListItemIcon>
              <ListItemText
                className="MenuItem__text"
                primary={t(item.text)}
                sx={{ opacity: openMenu ? 1 : 0 }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
};

export default Menu;
